import e from "../../hooks/useResizeObserver.js";
import t from "../../utils/classNames.js";
import n from "../button/Button.js";
import { useCallback as r, useLayoutEffect as i, useState as a } from "react";
import { AnimatePresence as o, motion as s, useReducedMotion as c } from "motion/react";
import { jsx as l, jsxs as u } from "react/jsx-runtime";
//#region src/components/pills/ScrollablePills.tsx
var d = 1, f = (e, t, n) => {
	let r = e.getBoundingClientRect(), i = t.getBoundingClientRect(), a = Math.max(e.scrollWidth - e.clientWidth, 0), o = Number.parseFloat(getComputedStyle(e.parentElement ?? e).getPropertyValue("--pills-scroll-content-edge-offset")), s = Number.isNaN(o) ? 0 : o, c = r.left + (e.scrollLeft > d ? s : 0), l = r.right - (a - e.scrollLeft > d ? s : 0), u = i.left < c ? i.left - c : i.right > l ? i.right - l : 0;
	if (Math.abs(u) <= d) return;
	let f = Math.min(Math.max(e.scrollLeft + u, 0), a);
	Math.abs(f - e.scrollLeft) <= d || e.scrollTo({
		behavior: n,
		left: f
	});
}, p = (p) => {
	let { className: m, children: h, filled: g, onScroll: _, previousButtonLabel: v, nextButtonLabel: y, ...b } = p, [x, S] = e(), [C, w] = a(!1), [T, E] = a(!1), D = c(), O = r(() => {
		let e = x.current;
		if (!e) return;
		let t = Math.max(e.scrollWidth - e.clientWidth, 0);
		w(e.scrollLeft > d), E(t - e.scrollLeft > d);
	}, [x]);
	i(() => {
		let e = x.current;
		if (!e) return;
		let t = e.querySelector(":scope > li.active");
		t && f(e, t, "auto"), O();
	}, [
		h,
		x,
		S,
		O
	]);
	let k = (e) => {
		O(), _?.(e);
	}, A = (e) => {
		let t = x.current;
		t && t.scrollBy({
			behavior: D ? "auto" : "smooth",
			left: t.clientWidth * (e === "next" ? .8 : -.8)
		});
	}, j = D ? {
		initial: !1,
		animate: { opacity: 1 },
		exit: { opacity: 1 }
	} : {
		initial: {
			opacity: 0,
			scale: .9
		},
		animate: {
			opacity: 1,
			scale: 1
		},
		exit: {
			opacity: 0,
			scale: .9
		}
	};
	return /* @__PURE__ */ u("div", {
		className: t("pills-scroll-wrapper min-width-0 width-100pct overflow-hidden", g && "pills-scroll-wrapper-filled", C && "pills-scroll-has-previous", T && "pills-scroll-has-next"),
		children: [/* @__PURE__ */ l("ul", {
			...b,
			ref: x,
			className: t(m, "nav-pills-scrollable min-width-0 width-100pct overflow-x-auto overflow-y-hidden"),
			onScroll: k,
			children: h
		}), /* @__PURE__ */ u(o, {
			initial: !1,
			children: [C && /* @__PURE__ */ l(s.div, {
				className: "pills-scroll-control pills-scroll-control-previous",
				...j,
				children: /* @__PURE__ */ l(n, {
					"aria-label": v,
					bsSize: n.XS,
					bsStyle: n.MUTED,
					className: t("pills-scroll-button", !g && "hover-bg-none"),
					iconName: "rioglyph-chevron-left",
					iconOnly: !0,
					onClick: () => A("previous")
				})
			}, "previous"), T && /* @__PURE__ */ l(s.div, {
				className: "pills-scroll-control pills-scroll-control-next",
				...j,
				children: /* @__PURE__ */ l(n, {
					"aria-label": y,
					bsSize: n.XS,
					bsStyle: n.MUTED,
					className: t("pills-scroll-button", !g && "hover-bg-none"),
					iconName: "rioglyph-chevron-right",
					iconOnly: !0,
					onClick: () => A("next")
				})
			}, "next")]
		})]
	});
};
//#endregion
export { p as default };

//# sourceMappingURL=ScrollablePills.js.map